import React from "react";
import { UseTheme } from "./ThemeProvider";
import { useSettingsQuery } from "@/api/queries/admin/SettingsQueries";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  alt?: string;
};

const BrandLogo: React.FC<Props> = ({ className, alt = "Logo" }) => {
  const { theme } = UseTheme();
  const { data } = useSettingsQuery(true);
  const branding = (data as any)?.branding_settings;
  const dark = theme === "dark";

  // Get the appropriate logo URL based on theme
  const logoUrl = dark ? branding?.logo_dark_url : branding?.logo_light_url;

  // If no logo is set, use the default project logo
  if (!logoUrl) {
    return <img src="/pwa-192x192.png" className={cn("h-8 w-auto object-contain", className)} alt={alt} />;
  }

  return <img src={logoUrl} className={cn("h-8 w-auto object-contain", className)} alt={alt} />;
};

export default BrandLogo;


